import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { MobileBottomNav } from "./MobileNav";
import OfflineBanner from "@/components/OfflineBanner";
import PwaActionCard from "@/components/PwaActionCard";
import TopBar from "./TopBar";
import CommandPalette from "./CommandPalette";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import SupportWidget from "@/components/SupportWidget";
import { useAuth } from "@/contexts/AuthContext";

export default function AppLayout() {
  const { user } = useAuth();
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
      if (e.key === "Escape") setPaletteOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen flex flex-col">
      <OfflineBanner />
      <ImpersonationBanner />
      <div className="flex-1 flex min-w-0">
        <Sidebar onOpenPalette={() => setPaletteOpen(true)} />
        <div className="flex-1 flex flex-col min-w-0 pb-14 lg:pb-0">
          <Outlet context={{ openPalette: () => setPaletteOpen(true) }} />
        </div>
      </div>
      <MobileBottomNav />
      <PwaActionCard />
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      <SupportWidget />
    </div>
  );
}

export function PageShell({ title, subtitle, right, children }) {
  const [paletteOpen, setPaletteOpen] = useState(false);
  return (
    <>
      <TopBar title={title} subtitle={subtitle} right={right} onOpenPalette={() => setPaletteOpen(true)} />
      <main className="flex-1 p-4 md:p-6 lg:p-8 max-w-[1600px] w-full mx-auto">{children}</main>
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </>
  );
}
